<section class="empty-state-section" animated fadeFrom="bottom">
    <ng-template #defaultState>
        <span *ngIf="!!icon" class="empty-state-image">
            <img [alt]="title?.title || text?.text || 'No items yet'" [ngSrc]="iconSrc" fill="true" priority="true"/>
        </span>

        <span *ngIf="showSpinner">
            <mat-spinner diameter="40"></mat-spinner>
            <button-spacer></button-spacer>
        </span>

        <ng-content></ng-content>

        <mat-toolbar class="empty-state-actions">
            <ng-content select="[mat-flat-button]"></ng-content>
        </mat-toolbar>
    </ng-template>

    <ng-container *ngIf="searchTerm; else defaultState">
        <span emptyStateTitle>{{ 'No results found for "' + searchTerm + '"' }}</span>
    </ng-container>
</section>
